// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1KlqB","title":"Header_title__1ynC3","side":"Header_side__1KHq9"};